import { render, staticRenderFns } from "./VolunteerProfileEvents.vue?vue&type=template&id=e1592830"
import script from "./VolunteerProfileEvents.vue?vue&type=script&lang=js"
export * from "./VolunteerProfileEvents.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports